
export const paperStyles = {
    p: 2.5,
    mb: 2.5,
    borderRadius: 2,
    border: '1px solid',
    bgcolor: 'background.paper',
    borderColor: 'divider',
    backgroundImage: 'none',
    backdropFilter: 'blur(10px)',
    fontFamily: '"Space Grotesk", sans-serif',
};

export const paperStylesDark = {
    ...paperStyles,
    bgcolor: 'rgba(33, 33, 33, 0.73)',
    borderColor: 'rgba(161, 161, 161, 0.1)',
    backgroundImage: 'linear-gradient(rgba(255, 255, 255, 0.05), rgba(255, 255, 255, 0.02))',
};

export const boxStyles = {
    p: 2,
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
};

// export const radioStyles = {
//     '&.Mui-checked': {
//         color: '#87cefa',
//         '& .MuiSvgIcon-root': {
//             '& circle': {
//                 fill: '#87cefa',
//             },
//         },
//     },
//     '& .MuiSvgIcon-root': {
//         fontSize: '1.1rem',
//         color: isDark ? 'rgba(255, 255, 255, 0.7)' : 'rgba(0, 0, 0, 0.6)',
//     },
//     '&:hover': {
//         backgroundColor: isDark ? 'rgba(255, 255, 255, 0.08)' : 'rgba(0, 0, 0, 0.04)',
//     },
// };

// export const labelStyles = {
//     m: 0,
//     p: 0.75,
//     borderRadius: 1,
//     '&:hover': {
//         bgcolor: isDark ? 'rgba(255, 255, 255, 0.08)' : 'action.hover',
//     },
//     '& .MuiFormControlLabel-label': {
//         fontSize: '0.8125rem',
//         fontWeight: 500,
//         color: isDark ? 'rgba(255, 255, 255, 0.9)' : 'text.primary',
//     },
//     '&.Mui-checked': {
//         backgroundColor: isDark ? 'rgba(255, 255, 255, 0.12)' : 'rgba(0, 0, 0, 0.08)',
//     },
// };

  